var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('model-viewer',{staticClass:"model-view",attrs:{"alt":"Item image","ar":"","ar-modes":"webxr scene-viewer quick-look","src":_vm.user.sprite_url}})}
var staticRenderFns = []

export { render, staticRenderFns }